import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FuseConfigService } from '../../../../core/services/config.service';
import { fuseAnimations } from '../../../../core/animations';

/** Query files */
import { ReportReviewQueryService } from '../../gql-query-mutation/index';

/**Local files */
import { spekwo, toastMsg, login } from '../../utils/index';

/**Local component */
import { ToastComponent } from '../../../../core/components/toast/toast.component';

/**Service file */

import { AuthService } from '../auth.service';

@Component({
    selector: 'fuse-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    animations: fuseAnimations
})

export class LoginComponent implements OnInit, OnDestroy {

    spekwoValues = spekwo;
    toastMsg = toastMsg;
    loginValues = login;

    loginForm: FormGroup;

    loginFormErrors: any;

    isResults: boolean = false;

    constructor(
        private fuseConfig: FuseConfigService,
        private formBuilder: FormBuilder,
        private router: Router,

        public toastComponent: ToastComponent,

        /**Query files */
        public reportReviewQueryService: ReportReviewQueryService,

        /**Service file */
        public authService: AuthService
    ) {

        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar: 'none',
                footer: 'none'
            }
        });

        this.loginFormErrors = {
            insId: {}
        };

    }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            insId: ['', Validators.required],
        });

        this.loginForm.valueChanges.subscribe(() => {
            this.onLoginFormValuesChanged();
        });
    }
    ngOnDestroy() {
    }

    onLoginFormValuesChanged() {

        for (const field in this.loginFormErrors) {

            if (!this.loginFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.loginFormErrors[field] = {};

            // Get the control
            const control = this.loginForm.get(field);


            if (control && control.dirty && !control.valid) {
                this.loginFormErrors[field] = control.errors;
            }
        }

    }

    /**Do login */
    doLogin() {

        this.isResults = true;
        this.authService.checkIsValidIdOnlogin(this.loginForm.get('insId').value.trim())
            .then((res: any) => {

                if (res && res.length > 0) {
                    const orderId = res[0].orderId;
                    this.toastComponent.showToast(this.toastMsg.successLogin);
                    window.localStorage.setItem('reportId', this.loginForm.get('insId').value.trim());
                    window.localStorage.setItem('orderId', orderId);
                    this.router.navigate(['inspection']);
                    // this.authService.getOrder(orderId)
                    //     .then(() => {
                    //         this.toastComponent.showToast(this.toastMsg.successLogin);
                    //         window.localStorage.setItem('reportId', this.loginForm.get('insId').value.trim());
                    //         window.localStorage.setItem('orderId', orderId);
                    //         this.router.navigate(['inspection']);
                    //     })
                    //     .catch(() => {
                    //         this.router.navigate(['**']);
                    //         this.toastComponent.showToast(this.toastMsg.failedLogin);
                    //     });


                    this.isResults = false;
                }
                else {
                    this.toastComponent.showToast(this.toastMsg.failedLogin);
                    this.isResults = false;
                }

            }).catch(() => {
                this.toastComponent.showToast(this.toastMsg.networkError);
                this.isResults = false;
            });
    }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/auth/login/login.component.ts